<script setup>
import { useRouter } from "vue-router";

const router = useRouter();
</script>

<template>
  <form-btn @click="router.back()" class="btn btn-icon btn-white">
    <i class="fas fa-arrow-right"></i>
  </form-btn>
</template>
